import { Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Analysis from "./pages/Analysis";
import TradingAgentsAnalysis from "./pages/TradingAgentsAnalysis";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Users from "./pages/admin/Users";
import Organization from "./pages/admin/Organization";
import Portfolio from "./pages/Portfolio";
import Backtest from "./pages/Backtest";
import CompareAnalysis from "./pages/CompareAnalysis";
import Watchlists from "./pages/Watchlists";
import Strategies from "./pages/Strategies";
import ApiKeys from "./pages/ApiKeys";
import Team from "./pages/Team";

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        {/* Wildcards let Clerk handle multi-step + SSO callback sub-routes */}
        <Route path="/login/*" element={<Login />} />
        <Route path="/signup/*" element={<Signup />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/analysis"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'create' }]}>
              <Layout>
                <Analysis />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/analysis/trading-agents"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'create' }]}>
              <Layout>
                <TradingAgentsAnalysis />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute permissions={[{ resource: 'reports', action: 'read' }]}>
              <Layout>
                <Reports />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute permissions={[{ resource: 'settings', action: 'read' }]}>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/portfolio"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'read' }]}>
              <Layout>
                <Portfolio />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/backtest"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'create' }]}>
              <Layout>
                <Backtest />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/compare"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'create' }]}>
              <Layout>
                <CompareAnalysis />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/watchlists"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'read' }]}>
              <Layout>
                <Watchlists />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/strategies"
          element={
            <ProtectedRoute permissions={[{ resource: 'analysis', action: 'read' }]}>
              <Layout>
                <Strategies />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/api-keys"
          element={
            <ProtectedRoute>
              <Layout>
                <ApiKeys />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/team"
          element={
            <ProtectedRoute>
              <Layout>
                <Team />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Admin routes */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute roles={['admin', 'manager']}>
              <Layout>
                <Users />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/organization"
          element={
            <ProtectedRoute roles={['admin']}>
              <Layout>
                <Organization />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
